"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XSRF_HEADER = exports.WEB2RAPI_SERVICE = exports.RETRY_DELAY_MS = exports.DESKTOP_TYPE = exports.DEFAULT_MAX_ATTEMPTS = exports.DEFAULT_CLIENT_TIMEOUT_MS = exports.CONTENT_TYPE_APPLICATION_JSON = void 0;
var CONTENT_TYPE_APPLICATION_JSON = "application/json";
exports.CONTENT_TYPE_APPLICATION_JSON = CONTENT_TYPE_APPLICATION_JSON;
var DEFAULT_CLIENT_TIMEOUT_MS = 68000;
exports.DEFAULT_CLIENT_TIMEOUT_MS = DEFAULT_CLIENT_TIMEOUT_MS;
var DEFAULT_MAX_ATTEMPTS = 3;
exports.DEFAULT_MAX_ATTEMPTS = DEFAULT_MAX_ATTEMPTS;
var RETRY_DELAY_MS = 3;
exports.RETRY_DELAY_MS = RETRY_DELAY_MS;
var XSRF_HEADER = "x-smar-xsrf";
exports.XSRF_HEADER = XSRF_HEADER;
var WEB2RAPI_SERVICE = "WEB2RAPI";
exports.WEB2RAPI_SERVICE = WEB2RAPI_SERVICE;
var DESKTOP_TYPE = {
  FULL_DESKTOP: 1,
  PUBLISH: 2,
  UPDATE: 3,
  GADGET: 4,
  CELL_SELECTOR: 5,
  EMBED: 6
};
exports.DESKTOP_TYPE = DESKTOP_TYPE;
//# sourceMappingURL=constants.js.map